import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, createVNode as _createVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-570f8f1e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "nav-left"
}
const _hoisted_2 = {
  key: 1,
  class: "nav-left"
}
const _hoisted_3 = {
  key: 2,
  class: "nav-middle"
}
const _hoisted_4 = {
  key: 3,
  class: "nav-middle"
}
const _hoisted_5 = {
  key: 4,
  class: "nav-right"
}
const _hoisted_6 = {
  key: 5,
  class: "nav-right"
}


import { HIconBackMediumM, HIconShareM } from '@nio-fe/horo-icons';
import { isInApp } from '@nio-wad/hooks';
import { nioJsBridge } from '@nio-wad/universal-bridge-h5';
import { Share2Config } from '@nio-wad/universal-bridge-h5/dist/types';
import {
  Component,
  computed,
  defineEmits,
  defineExpose,
  HTMLAttributes,
  nextTick,
  onMounted,
  ref,
  watch,
} from 'vue';

type ShareChannelType =
  | 'nio'
  | 'wx'
  | 'wx_mini_program' // 分享小程序
  | 'timeline'
  | 'weibo'
  | 'copy'
  | 'system_more'
  | 'download';

interface ShareParams {
  /** 别名：shareUrl, link */
  url: string;
  /** 别名：subTitle, desc */
  text: string;
  title: string;
  copyUrl?: string;
  type?: ShareChannelType[];
  files?: File[];
  /** 分享图片 */
  imgUrl?: string;
  topicId?: number; // 话题id(可以优先使用nioExtension参数)
  miniProgram?: { [key: string]: string }; // 分享小程序的参数
}
interface FullShareParams extends ShareParams {
  link: string;
  shareUrl: string;
  subTitle: string;
  desc: string;
}

const share = (args: ShareParams) => {
  const newArgs: FullShareParams = {
    ...args,
    link: args.url,
    shareUrl: args.url,
    desc: args.text,
    subTitle: args.text,
  };

  if (!newArgs.type)
    newArgs.type = [
      'nio',
      'wx',
      'timeline',
      'weibo',
      'copy',
      'system_more',
      'download',
    ];

  if (isInApp) {
    // share2 params
    // https://nio.feishu.cn/docx/XWdqdomt3o0Y51xHvP5ckBZVn8c
    // 修复：1. map 需要 return 默认值，2. switch 需有 default 分支
    const share2Params = newArgs.type
      .map((type) => {
        switch (type) {
          case 'nio':
            return 'niofriend';
          case 'wx':
            return 'wechatfriend';
          case 'wx_mini_program':
            return 'wxminiprogram';
          case 'timeline':
            return 'wechatcircle';
          case 'weibo':
            return 'weibo';
          case 'copy':
            return 'copylink';
          case 'system_more':
            return 'system';
          case 'download':
            return 'actionSave';
          default:
            // 默认返回原始 type，防止 map 返回 undefined
            return type;
        }
      })
      .reduce(
        (prev: any, curr) => {
          const channelParams = (curr: string) => {
            switch (curr) {
              case 'wxminiprogram':
                return 'wechatfriend';
                break;
              default:
                return curr;
                break;
            }
          };
          const functionParams = (curr: string) => {
            switch (curr) {
              case 'weibo':
                return 'share_webPage';
                break;
              case 'wxminiprogram':
                return 'share_miniProgram';
                break;
              default:
                return 'share_webPage';
                break;
            }
          };
          const config: any = {
            channel: channelParams(curr),
            title: newArgs.title,
            desc: newArgs.desc || newArgs.subTitle,
            imgUrl: newArgs.imgUrl,
            shareUrl: newArgs.url,
            url: newArgs.copyUrl || newArgs.url,
            function: functionParams(curr),
          };
          config.channel === 'wechatfriend' &&
            newArgs.miniProgram &&
            (config.miniProgram = newArgs.miniProgram); // 分享小程序
          // TODO: iOS 兼容性处理
          if (curr === 'weibo') {
            config.desc =
              (config.desc || config.title || '') +
              (config.shareUrl ? ` ${config.shareUrl}` : '');
          }
          prev.content.push(config);
          return prev;
        },
        { content: [] }
      );
    console.log(12345, share2Params);
    nioJsBridge.share2({
      data: share2Params as Share2Config,
    });
  } else {
    // TODO: implement wechat

    // for web
    navigator.share(newArgs);
  }
};

/** expose built-in menu items */
interface MenuItem {
  key?: string;
  icon?: Component;
  action: (...args: any[]) => any | string;
}
interface ShareItem extends MenuItem {
  bindArgs: (shareParams: ShareParams) => MenuItem;
  args?: ShareParams | null;
}

export const MENU_ITEMS = {
  SHARE: {
    key: 'share',
    icon: HIconShareM,
    action() {
      this.args && share(this.args);
    },
    bindArgs(args: ShareParams) {
      this.args = args;
      return this;
    },
    args: null,
  } as ShareItem,
};

export default /*#__PURE__*/_defineComponent({
  props: {
    title: { default: '' },
    transparent: { type: Boolean, default: false },
    menus: { default: () => [] },
    root: { default: null },
    transparentThreshold: { default: 0 },
    shareParams: { default: null },
    backStep: { default: '1' },
    shareIcon: { default: null },
    BackButtonComponent: { default: HIconBackMediumM },
    backButtonProps: { default: {} }
  },
  emits: ["onMenuClick"],
  setup(__props: any, { expose, emit }: { emit: ({
  (e: 'onMenuClick', ev: Event, target: MenuItem): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { title: string, transparent: boolean, menus: MenuItem[], root: Element | null, transparentThreshold: number, shareParams: ShareParams | null, backStep: string, shareIcon: Component | null, BackButtonComponent: Component, backButtonProps: any }



/** setup IntersectionObserver for $placeholder */
const $placeholder = ref<HTMLElement | null>(null);
const backgroundAlpha = ref(0);
let mountedPromiseResolve: any;
const mountedPromise = new Promise((resolve) => {
  mountedPromiseResolve = resolve;
});



onMounted(() => {
  mountedPromiseResolve();
  const observer = new IntersectionObserver(
    (entries, observer) => {
      if (!props.transparent) return;
      window.requestAnimationFrame(() => {
        entries.forEach((entry) => {
          const { boundingClientRect } = entry;
          const percentage =
            (boundingClientRect.height -
              Math.max(boundingClientRect.bottom, 0)) /
            boundingClientRect.height;
          backgroundAlpha.value = percentage;
        });
      });
    },
    {
      root: props.root || null,
      rootMargin: '0px',
      threshold: (() => {
        const threshold: number[] = [];
        for (let i = 0; i <= 100; i++) {
          threshold.push(i / 100);
        }
        return threshold;
      })(),
    }
  );
  $placeholder.value && observer.observe($placeholder.value);
});

/** 占位元素的高度。在透明状态下可以通过改变高度来调整导航栏变得完全非透明需要滚动的距离。
 * 在此状态下 placeholder 本身是绝对定义因此不占据空间，仅用来做 IntersectionObserver 的丈量
 */
const placeholderHeight = computed(() => {
  const style: HTMLAttributes['style'] = {};
  if (props.transparentThreshold) {
    style.height = `${props.transparentThreshold}px`;
  }
  return style;
});

/** if shareParams is provided, append a ShareItem to menus */
const wrappedShareMenuItem = computed(() => {
  if (props.shareParams && (props.menus || []).length === 0) {
    const menus = props.menus || [];
    menus.push(MENU_ITEMS.SHARE);
    return menus;
  }
  return props.menus;
});
watch(
  () => props.shareParams,
  (newValue, oldValue) => {
    newValue && (MENU_ITEMS.SHARE.args = newValue);
  },
  { immediate: true }
);

/** 菜单按钮元素，通常是个 icon */
const MenuComponent = computed(() => {
  const menus = wrappedShareMenuItem.value;
  if (menus?.length === 1) {
    return props.shareIcon || menus[0].icon;
  }
  return null;
});

/** 菜单被点击，当前只支持 1 个元素 */
const onMenuClick = (ev: MouseEvent) => {
  if (wrappedShareMenuItem.value?.length === 1) {
    try {
      wrappedShareMenuItem.value[0].action &&
        wrappedShareMenuItem.value[0].action();
    } catch (ex) {}
    emit('onMenuClick', ev, wrappedShareMenuItem.value[0]);
  }
};

const onBack = () => {
  if (isInApp) {
    nioJsBridge.back({
      data: {
        step: Number(props.backStep || 1),
      },
    });
  } else {
    history.back();
  }
};

/** 获取顶部状态栏高度 */
const safeAreaInsetTop = ref('0px');
const safeAreaPromise = (async () => {
  if (isInApp) {
    const res = await nioJsBridge.getOSInfo();
    const safeAreaInsets: Record<string, number> = res?.data
      ?.safeAreaInsets || {
      top: 0,
    };

    if (navigator.userAgent.toLocaleLowerCase().indexOf('android') !== -1) {
      for (const key of Object.keys(safeAreaInsets)) {
        safeAreaInsets[key] /= devicePixelRatio;
      }
    }

    safeAreaInsetTop.value = `${(safeAreaInsets as any).top}px`;
  }

  return new Promise((resolve) => {
    nextTick(() => {
      resolve(undefined);
    });
  });
})();

/** export header height */
const $container = ref<HTMLElement | null>(null);
expose({
  getHeight: (): Promise<number> =>
    Promise.all([mountedPromise, safeAreaPromise]).then(() =>
      $container.value ? $container.value.offsetHeight : 0
    ),
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({
      'navigation-bar': true,
      transparent: props.transparent,
      solid: !props.transparent,
    }),
    style: _normalizeStyle({ '--safe-area-inset-top': safeAreaInsetTop.value })
  }, [
    _createElementVNode("div", {
      class: "placeholder",
      ref_key: "$placeholder",
      ref: $placeholder,
      style: _normalizeStyle(_unref(placeholderHeight))
    }, null, 4),
    _createElementVNode("div", {
      class: "container",
      ref_key: "$container",
      ref: $container,
      style: _normalizeStyle({ '--background-alpha': backgroundAlpha.value })
    }, [
      (_ctx.$slots.left)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _renderSlot(_ctx.$slots, "left")
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(props.BackButtonComponent, _mergeProps({
              size: "24",
              onClick: onBack
            }, props.backButtonProps), null, 16)
          ])),
      (_ctx.$slots.middle)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _renderSlot(_ctx.$slots, "middle")
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(props.title), 1)),
      (_ctx.$slots.right)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _renderSlot(_ctx.$slots, "right")
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, [
            (_unref(MenuComponent))
              ? (_openBlock(), _createBlock(_unref(MenuComponent), {
                  key: 0,
                  size: "24",
                  class: "menu",
                  onClick: onMenuClick
                }))
              : _createCommentVNode("", true)
          ]))
    ], 4)
  ], 6))
}
}

})